import Link from './Link';
import { handleAnchorClick } from './Link.helpers';

export default Link;
export { handleAnchorClick };
